<template><div><h1 id="adressbereinigung-administrator" tabindex="-1"><a class="header-anchor" href="#adressbereinigung-administrator"><span>Adressbereinigung (Administrator)</span></a></h1>
<p>Adressbereinigung (Administrator) — Adressen manuell bereinigen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Ansicht können Adressen für die <RouteLink to="/referenz/refs/ft.refdata.adressbereinigunguser.html" title="Adressbereinigung">manuelle Adressbereinigung</RouteLink> den Benutzern zugewiesen werden.</p>
<p>Pfad: <code v-pre>Personen → Datenpflege → Bearbeitung manuell → Manuelle Bereinigung (Administrator)</code></p>
<h2 id="datenfelder-personenbereinigung-administrator" tabindex="-1"><a class="header-anchor" href="#datenfelder-personenbereinigung-administrator"><span>Datenfelder (Personenbereinigung Administrator)</span></a></h2>
<dl>
<dt>Filter</dt>
<dd>Auswahl eines Filters mit den zu bereinigenden Adressen.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Filters.</dd>
<dt>Gesamt</dt>
<dd>Anzahl Datensätze (Personen) im Filter die zu bereinigen sind.</dd>
<dt>zu verteilen</dt>
<dd>Anzahl Datensätze (Personen) die für die Bereinigung zu verteilen sind (noch nicht verteilte Datensätze).</dd>
<dt>zu bearbeiten</dt>
<dd>Anzahl Datensätze (Personen) die noch zu bearbeiten sind (inklusive noch nicht verteilte Datensätze).</dd>
<dt>Status</dt>
<dd>Dropdown-Manu, aktiv = zur Bearbeitung freigegeben, inaktiv = zur Bearbeitung noch nicht freigegeben</dd>
</dl>
<h2 id="datenfelder-zugeteilte-benutzer" tabindex="-1"><a class="header-anchor" href="#datenfelder-zugeteilte-benutzer"><span>Datenfelder (Zugeteilte Benutzer)</span></a></h2>
<dl>
<dt>BKz</dt>
<dd>Benutzerkürzel, zugeteilter Benutzer</dd>
<dt>Beschreibung</dt>
<dd>Benutzername des zugeteilten Benutzers</dd>
<dt>zugeteilt</dt>
<dd>Anzahl Datensätze (Personen) die dieser Benutzer zu bearbeiten hat (Zuweisung).</dd>
<dt>zu bearbeiten</dt>
<dd>Anzahl Datensätze (Personen) die durch diesen Benutzer noch zu bearbeiten sind (Read-Only, dient als Info).</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/adressbereinigung.html#Adressbereinigung" title="1. Adressbereinigung (manuell)">Adressbereinigung</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.adressbereinigunguser.html" title="Adressbereinigung">Adressen manuell bereinigen</RouteLink></p>
</div></template>


